// Define api end points here
export const AUTH = "/auth";
export const REGISTER = "/register";
export const LOGIN = "/login";

export const USER = "/user";
export const PROFILE_UPDATE = "/profile-update";
export const CATEGORIES = "/categories";

export const PRODUCTS = "/products";
export const GET_ALL_PRODUCTS = "/get-all-product";
export const PRODUCT = "/product";
export const GET_PRODUCT = "/get-product";

export const REVIEWS = "/reviews";
export const SUBMIT = "/submit";
export const WISH_LISTS = "/wishlists";
export const ADD = "/add";
export const STORE = "/store";
export const CONTACT = "/contact";

export const PAGES = "/pages";
export const ABOUT_US = "/about-us";

export const WISHLIST = "/wishlists";
export const REMOVE = "/remove";
export const ADDRESS = "/address";
export const ORDER = "/order";
export const PLACE_ORDER = "/place-order";
export const APPLY = "/apply";
export const COUPON = "/coupon";

export const SITE = "/site";
export const SITE_INFO = "/site-info";
export const FAQS = "/faqs";
export const GET_LIST = "/get-all";
export const DELETE = "/delete";
export const DEFAULT_ADDRESS = "/default-address";
export const UPDATE = "/update";
export const GET_ORDER = "/get-order";

export const BADGES = "/badges";
export const GET_SELLER_PROFILE = "/get-seller-profile";
export const GET_SELLER_BY_ID = "/get-seller";
export const GET_ORDERS = "/get-orders";
export const UPDATE_BUSINESS_PROFILE = "/update-business-profile";
export const SUB_CATEGORIES = "/sub-categories";
export const GET_PRODUCTS = "/get-products";
export const PRODUCT_ATTRIBUTE = "/product-attribute";
export const GET_CUSTOMERS = "/get-customers";
export const GET_REVIEWS = "/get-reviews";
export const FEEDBACK = "/feedback";
export const FROGOT_PASSWORD = "/forgot-password";
export const BANNERS = "/banners";
export const GET_HOME_SLIDERS = "/get-home-sliders";

export const UPDATE_PROFILE = "/update-profile";
export const RETURN = "/return";
export const CHANGE_ORDER_STATUS = "/change-order-status";
export const GET_RETURNs = "/get-returns";
export const RETURN_SELLER = "/return-seller";

// Apricot

export const FORGOT = "/forgot-password";
export const BLOGS = "/blogs";
export const GET_KIGI_FAQS = "/getKigiFaqs";

export const NEWS_LETTER = "/news-letter";
export const KIGI_NURSERY = "/kigi-nursery";
export const GET_KIGI_SITESETTINGS = "/getKigiSiteSettings";

export const CUSTOMER = "/customer";
export const URLS = "/urls";
export const BRANDS = "/brands";
export const CAMPAIGN = "/campaign";
export const GET_CAMPAIGN = "/getCampaign";
export const FIND_CAMPAIGN = "/findCampaign";

export const DONATE = "/donate";
export const MAKE_DONATION = "/makeDonation";
export const MEMBERSHIP = "/membership";
export const GET_MEMBERSHIP = "/getMemberships";

export const FIND_MEMBERSHIP = "/findMembership";
export const CSA_PRODUCT_PRICE = "/csa-product-price";

export const DETAILS = "/details";

export const RATING = "/rating";

export const LIST = "/list";
export const CHANGE_PASSWORD = "/change-password";
export const BLOG_DETAILS = "/blog-details";

export const CONTACTUS = "/contactUs";
export const GALLERY = "/gallery";
export const GET_IMAGES = "/getImages";
export const FILTER_TYPES = "/filter_types";

export const GIFT_CODE = "/gift-code";
export const GET_GIFT_CODE = "/getGiftCode";
export const SEND_GIFT_CODE = "/sendGiftCode";
export const GIFT_THEME = "/gift-theme";
export const GET_GIT_THEME = "/getGiftTheme";
export const GET_VIDEOS = "/getVideos";
export const MY_DONATION = "/my-donation";
export const MAKE_DEFAULT = "/make-default";

export const PLACE = "/place";

export const RESET_PASSWORD = "/reset-password";
export const SERVICES = "/services";
export const GET_SERVICES = "/getServices";

export const HOW_IT_WORKS = "/how-it-works";
export const GET_HOME_IT_WORKS = "/getHowItWorks";
export const PRODUCT_DATE = "/product-date";
export const GET_KIGI_SOCIAL_MEDIA = "/getKigiSocialMedia";
export const FREQUENTLY_BOUGHT = "/frequently-bought";
export const EDIT_ADDRESS = "/edit-address";

export const AVAILABLE_FRANCHISES = "/available-franchises";
export const SITE_SETTINGS = "/site-settings";
export const PROFILE = "/profile";

export const FRANCHISE = "/franchises";
export const CREATE = "/create";
export const DETAIL = "/detail";
export const STATUS = "/status";

export const LEADS = "/leads";
export const PURCHASE = "/purchase";
export const INVESTMENT_LEVELS = "/investment-levels";
export const CARDS = "/cards";
export const LEAD = "/lead";

export const PACKAGE = "/package";
export const CAR = "/car";
export const CONDITION = "/condition";

export const OPTIONS = "/options";
export const COLOR = "/color";
export const INSTANTOFFER = "/instant-offer";

export const ALL_LISTING = "/all-listing";
export const CAR_CATEGORY_ID = "?car_category_id";
export const MAKE_ID = "&make_id";
export const MODEL_ID = "&model_id";

export const ONBOARDING = "/generate-onboarding-link";
